module.exports = __webpack_public_path__ + "img/arrow-back.c29ddf53.svg";